<script>
    import {_} from 'svelte-i18n';
    import PackListing from '../PackListing.svelte';
    import {onMount} from 'svelte';
    import {goTo} from "../../utils.js";

    onMount(() => {
        window.scrollTo(0, 0);
        goTo('/supplies/specialEvents?tab=dividedNation', true);
    });
</script>

<PackListing storeSection="pvpArena" title={$_('DividedNationShopTab', {default: 'The Divided Nation'})}/>
